import { render, staticRenderFns } from "./DonorLFT.vue?vue&type=template&id=66e42772"
import script from "./DonorLFT.vue?vue&type=script&lang=js"
export * from "./DonorLFT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports